module.exports = __webpack_public_path__ + "static/media/verhuren-contact__cta.3bae671f.jpg";